import React from 'react'

function RedStar() {
    return (
        <strong><span style={{ color:'#EB0000'}}>*</span></strong>
        )
}
export default RedStar